import React from "react";
import { useSelector } from "react-redux";
import discoveryWidgetImg from "../../../../../assests/discovery/discoveryWidget.png"
import Widget from "../../../features/widget/Widget";
import iconsList from "../../../ui/icons/iconsList";
import pathRouts from "../../../../enums/pathRoute";
import classes from "./DiscoveryWidget.module.css";

const DiscoveryWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#C3D48B"
            title={texts.ContentLibrary}
            icon={iconsList.discovery}
            className={classes.DiscoveryWidget}
            mainLink={`/${pathRouts.DISCOVERY}`}
        >
            <div className={classes.DiscoveryContent}>
                <img
                    src={discoveryWidgetImg}
                    alt={texts.discovery}
                    className={classes.DiscoveryImg}
                />
                <div className={classes.DiscoveryText}>
                    {texts.NeedMaterialForTomorrowClass}
                </div>
            </div>
        </Widget>
    );
};

export default DiscoveryWidget;